<template>
    <div class="v-media-gallery d-flex align-items-center flex-column">
        <div class="v-media-gallery-main d-flex text-center mb-3 ratio-1-1">
            <div class="v-img-wrapper">
                <transition name="fade">
                    <t-img @click="expand" :src="mediaSrc" thumbnail fluid-grow v-if="mediaSrc" alt=""></t-img>
                </transition>
            </div>
        </div>
        <div class="v-media-gallery-thumbs d-flex flex-wrap align-items-start">
            <div
                class="v-media-item d-flex align-content-center"
                @click="selectMedia(mediaItem, key)"
                v-for="(mediaItem, key) in media" :key="key"
            >
                <t-img :src="mediaItem.original_url" thumbnail class="align-content-center" alt="Asset Image"></t-img>
            </div>
        </div>
        <b-modal v-model="openModal" modal-class="t-gallery-modal" size="xl" hide-footer centered>
            <div class="row">
                <div class="col-1">
                    <button class="btn btn-plain" @click.prevent="previous">
                        <i class="fal fa-chevron-left"></i>
                    </button>
                </div>
                <div class="col-10">
                    <transition name="fade">
                        <t-img v-if="modalSrc" :src="modalSrc" :key="selectedKey" thumbnail></t-img>
                    </transition>
                </div>
                <div class="col-1">
                    <button class="btn btn-plain" @click.prevent="next">
                        <i class="fal fa-chevron-right"></i>
                    </button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: {
        media: {
            default() {
                return [];
            },
        },
        placeholder: {
            type: String,
        },
    },
    data: () => ({
        mainProps: {
            center: true,
            fluidGrow: true,
            blank: true,
            blankColor: '#bbb',
            class: 'my-3',
        },
        openModal: false,
        selectedMedia: null,
        modalMedia: null,
    }),
    computed: {
        mediaSrc() {
            return _.get(this, 'selectedMedia.original_url', _.get(this, 'placeholder', ''));
        },
        modalSrc() {
            return _.get(this, 'modalMedia.original_url', _.get(this, 'placeholder', ''));
        },
    },
    created() {
        console.log(this.media);
        Bus.$on('setGalleryImages', this.setGalleryImages);
    },
    methods: {
        expand() {
            this.openModal = true;
        },
        selectMedia(mediaItem, key) {
            console.log(mediaItem);

            this.modalMedia = mediaItem;
            this.selectedMedia = mediaItem;
            this.selectedKey = key;
        },
        setGalleryImages({ media }) {
            this.selectedMedia = _.get(media, '0', {});
            this.modalMedia = this.selectedMedia;
            this.selectedKey = 0;
        },
        next() {
            let next = this.selectedKey + 1;
            Vue.set(this, 'selectedKey', _.has(this.media, next) ? next : 0);
            Vue.set(this, 'modalMedia', this.media[this.selectedKey]);
        },
        previous() {
            let prev = this.selectedKey - 1;
            Vue.set(this, 'selectedKey', _.has(this.media, prev) ? prev : this.media.length - 1);
            Vue.set(this, 'modalMedia', this.media[this.selectedKey]);
        },
    },
    beforeDestroy() {
        Bus.$off('setGalleryImages', this.setGalleryImages);
    },
    watch: {
        media: {
            deep: true,
            immediate: true,
            handler(newVal) {
                this.setGalleryImages({ media: newVal });
            },
        },
        placeholder: {
            deep: true,
            immediate: true,
            handler(newVal) {
                this.selectedMedia = newVal;
            },
        },
    },
};
</script>
